import PropTypes from 'prop-types'

import BrandingThemeProvider from './BrandingThemeProvider'
import {OrganizationCobrandingProvider} from './OrganizationCobrandingContext'

const BrandingProvider = ({children}) => (
  <OrganizationCobrandingProvider>
    <BrandingThemeProvider>
      {children}
    </BrandingThemeProvider>
  </OrganizationCobrandingProvider>
)

BrandingProvider.propTypes = {children: PropTypes.node.isRequired}

export default BrandingProvider